<template>
    <el-dialog class="open-private" :visible.sync="show" :title="$t('operations.turn_on.name')" width="30%"
        :close-on-click-modal="false" :before-close="handleClose">
        <p>{{ $t('game.list.openTip', [name]) }}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelOpen">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="sureOpen" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "Open",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        instanceId: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false
        }
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancelOpen() {
            this.handleClose();
        },
        sureOpen() {
            this.startInstance();
        },
        startInstance() {
            const params = {
                instanceId: this.instanceId,
                region: this.region,
                clientToken: Normal.getClientToken(),
            };
            Ajax.put('/api/cps/startInstance', params)
                .then()
                .catch()
                .finally(() => {
                    this.handleClose();
                    this.$emit('refresh')
                });
        }
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    }
}
</script>

<style lang="scss">
.open-private {}
</style>



// WEBPACK FOOTER //
// src/components/game/Open.vue